import { UpdateCurrentUserEmailScreenProps } from "./types"
import React, { useState } from "react"
import { observer } from "mobx-react-lite"
import Input from "~components/input"
import styled from '~/ui/styled'
import useCountdownThrottled from "~hooks/useCountdownThrottled"
import { useStores } from "~models"
import { Alert } from "~/ui/primitives"
import Spinner from "~/ui/spinner"
import useNavigation from "~hooks/useNavigation"

const SubmitWrapper = styled.Pressable`
  background-color: #07c160;
  border-radius: 8px;
  height: 40px;
  text-align: center;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`
const Submit = styled.Text`
  color: #fff;
`
const CurView = styled.View``
const CurText = styled.Text<{ color?: string; size?: number; weight?: string | number }>`
  font-size: ${({ size }) => (size ? `${size}px` : "12px")};
  color: ${({ color }) => color};
  font-weight: ${({ weight }) => weight || 300};
`

const UpdateCurrentUserEmail: React.FC<UpdateCurrentUserEmailScreenProps> = () => {
  const navigation = useNavigation()
  const { seconds, isCounting, startCountdown } = useCountdownThrottled(60)
  const { apiStore } = useStores()
  const [email, setEmail] = useState("")
  const [code, setCode] = useState("")
  const [isLoading, setIsloading] = useState(false)

  const onChangeEmailText = (text) => {
    setEmail(text)
  }

  const onChangeCodeText = (text) => {
    setCode(text)
  }

  const countDown = async () => {
    try {
      if (!email) {
        Alert.alert("请输入邮箱地址", "", [{ text: "OK" }])
        return
      }

      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!re.test(email)) {
        Alert.alert("请输入正确的邮箱地址", "", [{ text: "OK" }])
        return
      }

      setIsloading(true)

      const { code } = await apiStore.getEmailSms({ email })

      if (code === 200) {
        startCountdown()

        Alert.alert("发送成功", "", [{ text: "OK" }])
        setIsloading(false)
      }
    } catch (error) {
      Alert.alert(error.message, "", [{ text: "OK" }])
      setIsloading(false)
    }
  }

  const submitEmail = async () => {
    try {
      if (!email) {
        return Alert.alert("请输入邮箱地址", "", [{ text: "OK" }])
      }

      if (!code) {
        return Alert.alert("请输入验证码", "", [{ text: "OK" }])
      }

      setIsloading(true)

      const { code: codeStatus } = await apiStore.updateEmail({
        email,
        code,
      })

      if (codeStatus) {
        Alert.alert("修改成功", "", [{ text: "OK" }])
        navigation.goBack()
      }

      setIsloading(false)
    } catch (error) {
      Alert.alert(error.message, "", [{ text: "OK" }])
      setIsloading(false)
    }
  }
  return (
    <>
      <Spinner visible={isLoading} />
      <Input
        label="邮箱地址"
        placeholder="请输入您的邮箱地址"
        value={email}
        onChangeText={onChangeEmailText}
        operation={
          !isCounting ? (
            <CurText color="#07c160" onClick={countDown}>
              获取验证码
            </CurText>
          ) : (
            <CurText color="#AAAAAA">{seconds} 秒</CurText>
          )
        }
      />
      <Input
        label="验证码"
        placeholder="请输入邮箱验证码"
        value={code}
        onChangeText={onChangeCodeText}
      />
      {isCounting && (
        <CurView style={{ flexDirection: "row", justifyContent: "center", paddingTop: 10 }}>
          <CurText color="#DF2121">已发送验证码到邮箱{email}，有效期15分钟</CurText>
        </CurView>
      )}
      <CurView style={{ paddingHorizontal: 16, paddingVertical: 10 }}>
        <SubmitWrapper>
          <Submit onClick={submitEmail}>确认</Submit>
        </SubmitWrapper>
      </CurView>
    </>
  )
}

export default observer(UpdateCurrentUserEmail)
